import Reveal from "@/components/base/Reveal";
import { admissionSteps } from "@/mocks/admission";

export default function Process() {
  return (
    <section id="process" className="scroll-mt-24 bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-content px-5 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="font-label text-xs tracking-[0.25em] text-primary-600">
            ADMISSION PROCESS
          </span>
          <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-5xl">
            입학까지의 여정은
            <br />
            네 걸음으로 끝납니다
          </h2>
          <p className="mt-4 text-base leading-relaxed text-foreground-700">
            복잡한 절차 없이, 상담부터 학습 시작까지 빠르고 명확하게 진행됩니다.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-4">
          {admissionSteps.map((item, idx) => (
            <Reveal key={item.step} delay={idx * 80}>
              <article className="group relative h-full rounded-2xl border border-background-200 bg-background-100/70 p-6 transition-colors duration-300 hover:border-primary-300 md:p-7">
                <span className="font-heading text-5xl font-black text-background-300 transition-colors group-hover:text-primary-300">
                  {item.step}
                </span>
                <span className="mt-4 flex h-11 w-11 items-center justify-center rounded-xl bg-primary-500 text-foreground-950">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-700">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}